export default "__VITE_ASSET__CVGEDowN__"